import { gql } from '@apollo/client';

export const VANITY_ITEM_OWNERSHIP_STATS = gql`
  query VanityItemOwnershipStats(
    $category: VanityItemCategory!
    $vanityItemIdPrefix: String!
    $activeDays: Int
  ) {
    vanityItemOwnershipStats(
      category: $category
      vanityItemIdPrefix: $vanityItemIdPrefix
      activeDays: $activeDays
    ) {
      category
      vanityItemIdPrefix
      totalUsers
      activeUsers
      activeDays
      computedAt
      spendTiers {
        spendComputedAt
        spendSource
        total {
          npau
          minnow
          dolphin
          whale
          kraken
          uncategorized
        }
        active {
          npau
          minnow
          dolphin
          whale
          kraken
          uncategorized
        }
      }
    }
  }
`;

export const VANITY_ITEM_SPEND_TIER_USERS = gql`
  query VanityItemSpendTierUsers(
    $category: VanityItemCategory!
    $vanityItemIdPrefix: String!
    $activeDays: Int
    $scope: VanityOwnerScope!
    $tier: VanitySpendTier!
    $limit: Int
    $offset: Int
  ) {
    vanityItemSpendTierUsers(
      category: $category
      vanityItemIdPrefix: $vanityItemIdPrefix
      activeDays: $activeDays
      scope: $scope
      tier: $tier
      limit: $limit
      offset: $offset
    ) {
      users {
        userId
        name
      }
      total
      hasMore
    }
  }
`;
